/*
 * @Email: xuyujian@new4g.com
 * @Date: 2021-12-29 19:18:39
 * @Author: xuyujian
 */

import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'

/**
  * 账户限额设置列表
  */
export function accountManage (params = {}, config = { convertPageNumAndSize: true }) {
  return api.post(`${NO_PREFIX_URL}/accountManage.do`, params, config, 'URLEncoded')
}

/**
 * // 账户修改结果
 */

export function accountUpdate (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/accountUpdate.do`, params, config, 'URLEncoded')
}

/**
  * 获取每日限额详情
  * @param {string} accountNo 账号
  */
export function accountUpdateShow (params = {}, config = {}) {
  return api.post('/api/transfer/acct/limit/accountUpdateShow', params, config, 'URLEncoded')
}

// 密码重置审批--start
/**
  * 申请列表
  */
export function applyResetQuery (params = {}, config = { convertPageNumAndSize: true }) {
  return api.post(`${NO_PREFIX_URL}/applyResetQuery.do`, params, config, 'URLEncoded')
}

/**
  * 审批操作
  * @param {string} customerId 企业客户号
  * @param {string} userId 企业操作员
  * @param {string} resetStt 1: 同意，2拒绝
  * @param {string} resetSdfsdf session_userId
  * @param {string} currentBusinessCode 00000000
  */
export function sdfResetPassword (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/sdfResetPassword.do`, params, config, 'URLEncoded')
}

/**
  * 重置密码
  * @param {string} session_customerId customerId
  * @param {string} session_userId userId
  * @param {string} firstLogOn 日志：1
  * @param {string} currentBusinessCode 00000000
  */
export function resetPasswordApply (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/resetPasswordApply.do`, params, config, 'URLEncoded')
}

/**
  * 查询用户操作日志
  * @param {string} userId : userid,
  * @param {string} beginDate : beginDate,
  * @param {string} endDate : endDate,
  * @param {string} optType : optType,
  * @param {string} orderState : orderState,
  * @param {string} currentBusinessCode:'99992000',
  * @param {string} pageFlag : pageFlag,
  * @param {number} pageSize
  * @param {number} pageNum
  * @param {string} currentBusinessCode 99992000
  */
export function userLogQry (params = {}, config = {
}) {
  return api.get(`${NO_PREFIX_URL}/userLogQry.do`, params, config, 'URLEncoded')
}
/**
  * 查询企业管理授权列表
  * @param {string} currentBusinessCode 10700500
  */
export function enterConsoleAuthCenter (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/enterConsoleAuthCenter.do`, params, config, 'URLEncoded')
}
/**
  * 查询待处理指令列表
  * @param {string} businessCode
  * @param {string} currentBusinessCode 10700000
  */
export function getOrderListOf100401 (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/100401_orderList.do`, params, {
    ...config,
    convertPageNumAndSize: true
  }, 'URLEncoded')
}

export function getOrderListOf10700600 (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/10700600_orderList.do`, params, {
    ...config,
    convertPageNumAndSize: true
  }, 'URLEncoded')
}

/**
  * 账户管理明细
  * @param {object}
  */
export function getOrderDetailOf10700600 (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/10700600_orderDetail.do`, params, {
    ...config
  }, 'URLEncoded')
}
/**
  * 开通业务明细
  * @param {object}
  */
export function getOrderDetailOf100401 (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/100401_orderDetail.do`, params, config, 'URLEncoded')
}
/**
  * 授权-拒绝
  * @param {object}
  */
export function orderRefuseOf100401 (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/100401_orderRefuse.do`, params, config, 'URLEncoded')
}

/**
  * 授权-通过
  * @param {object}
  */
export function orderAcceptOf100401 (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/100401_orderAccept.do`, params, config, 'URLEncoded')
}
/**
  * 账户管理授权拒绝
  * @param {object}
  */
export function orderRefuseOf10700600 (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/10700600_orderRefuse.do`, params, config, 'URLEncoded')
}

/**
  * 账户管理授权通过
  * @param {object}
  */
export function orderAcceptOf10700600 (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/10700600_orderAccept.do`, params, config, 'URLEncoded')
}

/**
  * 查询用户号维护列表
  * @param {string} currentBusinessCode 10700000
  * @param {string} turnPageShowNum 10
  * @param {string} turnPageBeginPos 1
  */
export function userManage (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/userManage.do`, params, config, 'URLEncoded')
}

/**
  * 查询用户修改页面显示
  * @param {string} currentBusinessCode 10700000
  * @param {string} userId
  */
export function operatorUpdate (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/operatorUpdate.do?`, params, config, 'URLEncoded')
}

/**
  * 用户修改基本信息
  * @param {string} currentBusinessCode 10700000
  * @param {string} userId
  */
export function userUpdateInfo (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/userUpdateInfo.do`, params, config, 'URLEncoded')
}

/**
  * 获取可操作账户列表
  * @param {string} currentBusinessCode 10700000
  * @param {string} userId
  */
export function accountList (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/accountList.do`, params, config, 'URLEncoded')
}
/**
  * 修改可操作账户列表
  * @param {string} currentBusinessCode 10700000
  * @param {string} userId
  * @param {string} actionType 03
  * @param {Array<string>} iUserAccountList.accountNo
  * @param {Array<string>} iUserAccountList.accountName
  * @param {Array<string>} iUserAccountList.currencyType
  * @param {Array<string>} iUserAccountList.accountType
  */
export function userUpdateAcc (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/userUpdateAcc.do`, params, config, 'URLEncoded')
}
/**
  * 获取可操作业务列表
  * @param {string} currentBusinessCode 10700000
  * @param {string} userId
  */
export function perationalBusinessList (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/perationalBusinessList.do`, params, config, 'URLEncoded')
}
/**
  * 修改可操作业务列表
  * @param {string} currentBusinessCode 10700000
  * @param {string} userId
  * @param {string} actionType 04
  * @param {Array<string>} iUserBusinessList.businessCode
  */
export function userUpdateBsn (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/userUpdateBsn.do`, params, config, 'URLEncoded')
}
/**
 * U盾证书信息
 */
export function certUpdate (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/certUpdate.do`, params, config, 'URLEncoded')
}
/**
 * 更新u盾证书
 * @param {string} currentBusinessCode 10700500
 * @param {string} toAmount u盾费用
 */
export function certUpdateSubmit (params = {}, config = {}) {
  return api.post(`${NO_PREFIX_URL}/certUpdateSubmit.do`, params, config, 'URLEncoded')
}
